export const GET_INSPECTOR_FILTERS_REQUEST = "GET_INSPECTOR_FILTERS_REQUEST";
export const GET_INSPECTOR_FILTERS_SUCCESS = "GET_INSPECTOR_FILTERS_SUCCESS";
export const GET_INSPECTOR_FILTERS_FAIL = "GET_INSPECTOR_FILTERS_FAIL";

export const EVALUATE_INSPECTORS_REQUEST = "EVALUATE_INSPECTORS_REQUEST";
export const EVALUATE_INSPECTORS_SUCCESS = "EVALUATE_INSPECTORS_SUCCESS";
export const EVALUATE_INSPECTORS_FAIL = "EVALUATE_INSPECTORS_FAIL";

export const GET_SUPERVISOR_FILTERS_REQUEST = "GET_SUPERVISOR_FILTERS_REQUEST";
export const GET_SUPERVISOR_FILTERS_SUCCESS = "GET_SUPERVISOR_FILTERS_SUCCESS";
export const GET_SUPERVISOR_FILTERS_FAIL = "GET_SUPERVISOR_FILTERS_FAIL";

export const EVALUATE_SUPERVISORS_REQUEST = "EVALUATE_SUPERVISORS_REQUEST";
export const EVALUATE_SUPERVISORS_SUCCESS = "EVALUATE_SUPERVISORS_SUCCESS";
export const EVALUATE_SUPERVISORS_FAIL = "EVALUATE_SUPERVISORS_FAIL";

export const GET_MUNICIPALITY_FILTERS_REQUEST = "GET_MUNICIPALITY_FILTERS_REQUEST";
export const GET_MUNICIPALITY_FILTERS_SUCCESS = "GET_MUNICIPALITY_FILTERS_SUCCESS";
export const GET_MUNICIPALITY_FILTERS_FAIL = "GET_MUNICIPALITY_FILTERS_FAIL";

export const EVALUATE_MUNICIPALITY_REQUEST = "EVALUATE_MUNICIPALITY_REQUEST";
export const EVALUATE_MUNICIPALITY_SUCCESS = "EVALUATE_MUNICIPALITY_SUCCESS";
export const EVALUATE_MUNICIPALITY_FAIL = "EVALUATE_MUNICIPALITY_FAIL";